(function () {
  'use strict';

  // ¥1 variant を quantity=保証金額 で追加する方式（percentage pricing用）
  // 実際の variant ID に変更してください
  var GUARANTEE_ONE_YEN_VARIANT_ID = 45732712874041;

  function init() {
    var mount = document.getElementById('kpw-product-options');
    if (!mount) return;

    var formId = mount.dataset.formId;
    var form = document.getElementById(formId);
    if (!form) return;

    var productPriceCents = parseInt(mount.dataset.productPrice, 10) || 0;
    var productTitle = mount.dataset.productTitle || '';
    var options;

    try {
      options = JSON.parse(mount.dataset.options);
    } catch (e) {
      console.warn('[kpw-options] JSON parse error:', e.message);
      return;
    }

    if (!options || options.length === 0) return;

    options.sort(function (a, b) { return a.sort - b.sort; });

    var qtyInput = form.querySelector('[name="quantity"]');
    function getCurrentQty() {
      return Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
    }

    // --- 数量ボタン ---
    // --- UI を mount の中に直接生成 ---
    var container = document.createElement('div');
    container.id = 'kpw-options-ui';
    container.className = 'kpw-options-container';

    options.forEach(function (opt) {
      var block = document.createElement('div');
      block.className = 'kpw-option-block';
      block.dataset.optionKey = opt.key;

      if (opt.ui === 'radio') {
        block.innerHTML = buildRadioHTML(opt, getCurrentQty(), productPriceCents);
      } else if (opt.ui === 'checkbox') {
        block.innerHTML = buildCheckboxHTML(opt, productPriceCents, getCurrentQty());
      }

      container.appendChild(block);
    });

    mount.appendChild(container);

    // --- 数量変更 → 価格表示を再計算 ---
    function onQtyChange() {
      refreshQtyLinkedPrices(form, options, getCurrentQty(), productPriceCents);
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', onQtyChange);
      qtyInput.addEventListener('input', onQtyChange);
    }

    form.querySelectorAll('.js-qty__adjust').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(onQtyChange, 0);
      });
    });

    if (qtyInput) {
      var lastQty = qtyInput.value;
      new MutationObserver(function () {
        if (qtyInput.value !== lastQty) {
          lastQty = qtyInput.value;
          onQtyChange();
        }
      }).observe(qtyInput, { attributes: true, attributeFilter: ['value'] });
    }

    // --- バリアント変更 → percentage系の再計算 ---
    document.addEventListener('variant:changed', function (e) {
      if (e.detail && e.detail.variant) {
        productPriceCents = e.detail.variant.price;
        refreshPercentageOptions(form, options, productPriceCents, getCurrentQty());
      }
    });

    // --- フォームsubmitを完全制御 ---
    var btn = form.querySelector('[data-add-to-cart]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart(form, options, productTitle, btn, getCurrentQty());
    }, true);
  }

  // ---- UI builders ----

  // choice.price が % 値のとき yen 換算する
  // productPriceCents: Shopify cents 単位（JPY でも ×100）
  function calcDisplayPrice(c, optPricing, productPriceCents) {
    if (optPricing === 'percentage') {
      var productPriceYen = Math.round((productPriceCents || 0) / 100); // cents → yen
      return Math.round(productPriceYen * (c.price / 100));
    }
    return c.price; // fixed/per_quantity は DB の yen 値そのまま
  }

  function choicePriceText(choice, qty) {
    var pricing = choice.pricing || 'fixed';
    if (isQuantityLinkedOption(pricing, choice.label) && qty > 1) {
      var total = choice.price * qty;
      return '+\xA5' + choice.price.toLocaleString('ja-JP') + ' \xD7 ' + qty + ' = \xA5' + total.toLocaleString('ja-JP');
    }
    return '+\xA5' + choice.price.toLocaleString('ja-JP');
  }

  function isQuantityLinkedOption(pricing) {
    return pricing !== 'percentage';
  }

  function buildRadioHTML(opt, qty, productPriceCents) {
    var isPercent = (opt.pricing === 'percentage');

    var none = '<label class="kpw-choice">'
      + '<input type="radio" name="kpw_' + opt.key + '" value="" data-price="0" data-pricing="fixed" data-opt-pricing="' + (opt.pricing || 'fixed') + '" data-label="" checked>'
      + '<span>\u306A\u3057</span></label>';

    var choices = (opt.choices || []).map(function (c) {
      var pricing = c.pricing || 'fixed';
      var displayYen = calcDisplayPrice(c, opt.pricing, productPriceCents);
      var displayText = isPercent
        ? '+\xA5' + displayYen.toLocaleString('ja-JP')
        : choicePriceText({ price: displayYen, pricing: pricing }, qty);

      return '<label class="kpw-choice">'
        + '<input type="radio" name="kpw_' + opt.key + '"'
        + ' value="' + c.variant_id + '"'
        + ' data-price="' + displayYen + '"'
        + ' data-pricing="' + pricing + '"'
        + ' data-opt-pricing="' + (opt.pricing || 'fixed') + '"'
        + ' data-label="' + escAttr(c.label) + '">'
        + '<span>' + escHTML(c.label) + ' (' + displayText + ')</span></label>';
    }).join('');

    return '<p class="kpw-option-title">' + escHTML(opt.label) + '</p>'
      + '<div class="kpw-choices">' + none + choices + '</div>';
  }

  function buildCheckboxHTML(opt, productPriceCents, qty) {
    var choice, basePrice, displayText;

    if (opt.pricing === 'percentage') {
      choice = opt.choices && opt.choices[0];
      if (!choice) return '';
      var productPriceYen = Math.round((productPriceCents || 0) / 100); // cents → yen
      basePrice = Math.round(productPriceYen * (choice.price / 100));   // yen
      displayText = '+\xA5' + basePrice.toLocaleString('ja-JP');
    } else {
      choice = opt.choices && opt.choices[0];
      if (!choice) return '';
      basePrice = choice.price;
      var pricing = choice.pricing || opt.pricing || 'fixed';
      displayText = (isQuantityLinkedOption(pricing, opt.label) && qty > 1)
        ? '+\xA5' + basePrice.toLocaleString('ja-JP') + ' \xD7 ' + qty + ' = \xA5' + (basePrice * qty).toLocaleString('ja-JP')
        : '+\xA5' + basePrice.toLocaleString('ja-JP');
    }

    var pricing = choice.pricing || opt.pricing || 'fixed';
    return '<label class="kpw-choice kpw-checkbox">'
      + '<input type="checkbox" name="kpw_' + opt.key + '"'
      + ' value="' + choice.variant_id + '"'
      + ' data-price="' + basePrice + '"'
      + ' data-pricing="' + pricing + '"'
      + ' data-opt-pricing="' + (opt.pricing || 'fixed') + '"'
      + ' data-label="' + escAttr(opt.label) + '">'
      + '<span>' + escHTML(opt.label) + ' (' + displayText + ')</span></label>';
  }

  function refreshQtyLinkedPrices(form, options, qty, productPriceCents) {
    options.forEach(function (opt) {
      if (opt.pricing === 'percentage') return; // percentage は refreshPercentageOptions が担当
      var block = form.querySelector('[data-option-key="' + opt.key + '"]');
      if (!block) return;

      if (opt.ui === 'radio') {
        (opt.choices || []).forEach(function (c) {
          if (!isQuantityLinkedOption(c.pricing || 'fixed', c.label)) return;
          var input = block.querySelector('input[value="' + c.variant_id + '"]');
          if (!input) return;
          var span = input.parentElement ? input.parentElement.querySelector('span') : null;
          if (span) span.textContent = c.label + ' (' + choicePriceText(c, qty) + ')';
        });
      } else if (opt.ui === 'checkbox') {
        var choice = opt.choices && opt.choices[0];
        if (!choice) return;
        var pricing = choice.pricing || opt.pricing || 'fixed';
        if (!isQuantityLinkedOption(pricing, opt.label)) return;
        var input = block.querySelector('input[type="checkbox"]');
        if (!input) return;
        var basePrice = choice.price;
        var total = basePrice * qty;
        var displayText = qty > 1
          ? '+\xA5' + basePrice.toLocaleString('ja-JP') + ' \xD7 ' + qty + ' = \xA5' + total.toLocaleString('ja-JP')
          : '+\xA5' + basePrice.toLocaleString('ja-JP');
        var span = input.parentElement ? input.parentElement.querySelector('span') : null;
        if (span) span.textContent = opt.label + ' (' + displayText + ')';
      }
    });
  }

  function refreshPercentageOptions(form, options, newPriceCents, qty) {
    options.forEach(function (opt) {
      if (opt.pricing !== 'percentage') return;
      var block = form.querySelector('[data-option-key="' + opt.key + '"]');
      if (!block) return;

      var newPriceYen = Math.round(newPriceCents / 100); // cents → yen（バリアント変更時も同様）

      if (opt.ui === 'checkbox') {
        var choice = opt.choices && opt.choices[0];
        if (!choice) return;
        var yenAmount = Math.round(newPriceYen * (choice.price / 100)); // yen
        var input = block.querySelector('input[type="checkbox"]');
        if (!input) return;
        input.dataset.price = yenAmount; // data-price は常に yen
        var span = input.parentElement ? input.parentElement.querySelector('span') : null;
        if (span) span.textContent = opt.label + ' (+\xA5' + yenAmount.toLocaleString('ja-JP') + ')';
      } else if (opt.ui === 'radio') {
        (opt.choices || []).forEach(function (c) {
          var yenAmount = Math.round(newPriceYen * (c.price / 100)); // yen
          var input = block.querySelector('input[value="' + c.variant_id + '"]');
          if (!input) return;
          input.dataset.price = yenAmount; // data-price は常に yen
          var span = input.parentElement ? input.parentElement.querySelector('span') : null;
          if (span) span.textContent = c.label + ' (+\xA5' + yenAmount.toLocaleString('ja-JP') + ')';
        });
      }
    });
  }

  // ---- Cart API ----

  function addToCart(form, options, productTitle, btn, qty) {
    var span = btn ? btn.querySelector('[data-add-to-cart-text]') : null;
    var originalText = span ? span.textContent.trim() : '';

    if (btn) btn.disabled = true;
    if (span) span.textContent = '\u8FFD\u52A0\u4E2D...';

    var variantSelect = form.querySelector('[data-product-select]');
    var mainVariantId = variantSelect ? parseInt(variantSelect.value, 10) : 0;
    if (!mainVariantId) {
      restoreBtn(btn, span, originalText);
      return;
    }

    var selected = [];
    options.forEach(function (opt) {
      var input = form.querySelector('input[name="kpw_' + opt.key + '"]:checked');
      if (!input || input.value === '') return;
      var pricing    = input.dataset.pricing    || 'fixed';
      var optPricing = input.dataset.optPricing || 'fixed';
      var basePrice  = parseInt(input.dataset.price, 10) || 0; // 常に円換算済み
      var quantityLinked = isQuantityLinkedOption(pricing, input.dataset.label || opt.label);
      var totalPrice = quantityLinked ? basePrice * qty : basePrice;
      var propValue  = (qty > 1 && quantityLinked)
        ? input.dataset.label + ' \xD7 ' + qty + ' (+\xA5' + totalPrice.toLocaleString('ja-JP') + ')'
        : input.dataset.label + ' (+\xA5' + totalPrice.toLocaleString('ja-JP') + ')';
      selected.push({
        opt: opt,
        variantId:  parseInt(input.value, 10),
        pricing:    pricing,
        optPricing: optPricing,
        quantityLinked: quantityLinked,
        basePrice:  basePrice,
        propValue:  propValue,
        label:      input.dataset.label || ''
      });
    });

    var mainProps = {};
    var hasProps = false;
    selected.forEach(function (s) {
      mainProps[s.opt.label] = s.propValue;
      hasProps = true;
    });

    var items = [{ id: mainVariantId, quantity: qty }];
    if (hasProps) items[0].properties = mainProps;

    // percentage 以外のオプションのみ companion variant を追加
    var groupId = null;

    selected.forEach(function (s) {
      if (!s.variantId) return;

      if (s.optPricing === 'percentage') {
        // ¥1 variant を 保証金額(円) 個 追加して正確な金額を請求する
        // s.basePrice は data-price から取得 = yen 値（calcDisplayPrice / buildCheckboxHTML で変換済み）
        var insuranceYen = s.basePrice; // yen
        if (insuranceYen > 0 && GUARANTEE_ONE_YEN_VARIANT_ID) {
          if (!groupId) {
            groupId = 'kpw_' + Date.now() + '_' + Math.floor(Math.random() * 1000000);
            if (!items[0].properties) items[0].properties = {};
            items[0].properties['_kpw_group'] = groupId;
          }
          items.push({
            id: GUARANTEE_ONE_YEN_VARIANT_ID,
            quantity: insuranceYen,
            properties: {
              '_kpw_group': groupId,
              '_kpw_role':  'option',
              '_pricing':   'percentage',
              '_display':   '\u751F\u4F53\u4FDD\u8A3C \xA5' + insuranceYen.toLocaleString('ja-JP')
            }
          });
        }
        return;
      }

      if (!groupId) {
        groupId = 'kpw_' + Date.now() + '_' + Math.floor(Math.random() * 1000000);
        if (!items[0].properties) items[0].properties = {};
        items[0].properties['_kpw_group'] = groupId;
      }

      var companionQty = s.quantityLinked ? qty : 1;
      items.push({
        id: s.variantId,
        quantity: companionQty,
        properties: {
          '_kpw_group': groupId,
          '_kpw_role':  'option',
          '_pricing':   s.pricing,
          '_display':   s.label
        }
      });
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) {
      if (!res.ok) {
        return res.text().then(function (rawText) {
          var err;
          try { err = JSON.parse(rawText); } catch (e) { err = {}; }
          throw new Error(err.description || rawText || '\u30AB\u30FC\u30C8\u3078\u306E\u8FFD\u52A0\u306B\u5931\u6557\u3057\u307E\u3057\u305F');
        });
      }
      window.location.href = '/cart';
    })
    .catch(function (err) {
      alert(err.message || '\u30AB\u30FC\u30C8\u3078\u306E\u8FFD\u52A0\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002');
      restoreBtn(btn, span, originalText);
    });
  }

  function restoreBtn(btn, span, text) {
    if (btn) btn.disabled = false;
    if (span) span.textContent = text;
  }

  // ---- Utilities ----

  function nearestChoice(choices, targetYen) {
    if (!choices || choices.length === 0) return null;
    return choices.reduce(function (best, c) {
      return Math.abs(c.price - targetYen) < Math.abs(best.price - targetYen) ? c : best;
    });
  }

  function escHTML(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function escAttr(s) {
    return String(s).replace(/"/g, '&quot;');
  }

  // ---- Boot ----

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
